import { Space, StatusLabel, StatusLabelStatuses, SubText } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { type GlobalSearchResultTypeEnum } from '../../../../../../value-objects/enums'
import { type GlobalSearchItemMetadata } from '../../../../../../value-objects/GlobalSearchItemMetadata'
import { useFormatGlobalSearchDateLabel } from '../../hooks/useFormatGlobalSearchDateLabel'
import { useFormatGlobalSearchIdentifierLabel } from '../../hooks/useFormatGlobalSearchIdentifierLabel'
import { GlobalSearchListItemStatusLabel } from '../GlobalSearchListItemStatusLabel'

interface IGlobalSearchListItemMetadataProps {
  type: GlobalSearchResultTypeEnum
  metadata: GlobalSearchItemMetadata
}

export const GlobalSearchListItemMetadata = ({
  type,
  metadata,
}: IGlobalSearchListItemMetadataProps) => {
  const intl = useProcurifyIntl()
  const formatDateLabel = useFormatGlobalSearchDateLabel()
  const formatIdentifierLabel = useFormatGlobalSearchIdentifierLabel()

  const status = 'status' in metadata ? metadata.status : null
  const dateLabel =
    'date' in metadata ? formatDateLabel(type, metadata.date) : null
  const identifierLabel = formatIdentifierLabel(metadata)
  const isPreferredVendor =
    'isPreferredVendor' in metadata && metadata.isPreferredVendor

  if (!status && !dateLabel && !identifierLabel && !isPreferredVendor) {
    return null
  }

  return (
    <Space direction='horizontal' size='small' align='center'>
      {status && (
        <GlobalSearchListItemStatusLabel resultType={type} status={status} />
      )}
      {isPreferredVendor && (
        <StatusLabel
          type={StatusLabelStatuses.INFO}
          text={intl.formatMessage(messages.preferredVendorLabel)}
          fontSize={12}
          paddingSize='small'
        />
      )}
      {(identifierLabel || dateLabel) && (
        <SubText noWrap textEllipsis color='textSecondary'>
          {identifierLabel && dateLabel
            ? intl.formatMessage(messages.identifierAndDateLabel, {
                identifier: identifierLabel,
                date: dateLabel,
              })
            : identifierLabel || dateLabel}
        </SubText>
      )}
    </Space>
  )
}
